import { CSSObject } from '@chakra-ui/react';

export const SideNavHeading: CSSObject = {
  '&&': {
    mb: '0',
  },
  fontFamily: 'Roboto',
};

export const FlexSideLinkWrapper: CSSObject = {
  fontFamily: 'Roboto',
  fontSize: '12px',
  fontWeight: 'bold',
  textTransform: 'uppercase',
};
